export default __webpack_public_path__ + "static/media/bolsas.c1c3e9e8.pdf";